import { RG_TYPE as t } from "@project-rouge/rg-core";
import { getLevelArea as m } from "./index4.js";
const a = (e, r) => m(e, r, [t.EmptySpace]);
export {
  a as getLevelCommercialArea
};
//# sourceMappingURL=index10.js.map
